import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4a451cae"
import script from "./Index.js?vue&type=script&lang=js&external"
export * from "./Index.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=4a451cae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports